"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    rx: "2",
    ry: "2",
    style: {
      fill: '#93c01f'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,4.22a1.44,1.44,0,0,0-2.6-.61L8.66,17.28,5.48,14a1.37,1.37,0,0,0-1-.43A1.33,1.33,0,0,0,3.43,14a1.47,1.47,0,0,0,0,2L7.8,20.56a1.41,1.41,0,0,0,1,.44A1.43,1.43,0,0,0,10,20.39L20.73,5.3A1.46,1.46,0,0,0,21,4.22Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;